import React, { useMemo } from 'react';
import NoDataComponent from '../../../dashboard_gen2/no_data_component.jsx';
import { useSelector } from 'react-redux';

function EmbedWidget({ widgetId }) {
    const content_src = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_src);
    const content_url = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_url);
    const content_html = useSelector(state => state.dashboard.widgets[widgetId].settings?.content_html) || "";
    const parameters = useSelector(state => state.dashboard.widgets[widgetId].settings?.parameters);
    const src = content_url + parameters
    // Default padding of body is determined by the browser, therefore, set to 0 to make sure that widget is filled
    const iframeContent = useMemo(() => `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body {
              margin: 0;
              padding: 0;
            }
          </style>
        </head>
        <body>
          ${content_html.replace("</script>", "<\/script>")}
        </body>
      </html>
    `, [content_html])


    if (content_src == 'HTML') {
      return content_html === '' ? <NoDataComponent /> : <iframe style={{width: '100%', height: '100%', border: 'none'}} srcDoc={iframeContent} sandbox=''></iframe>
    }

    return content_url === '' ? <NoDataComponent /> : <iframe style={{width: '100%', height: '100%', border: 'none'}} src={src} sandbox=''></iframe>
}

export default EmbedWidget;
